module.exports = __webpack_public_path__ + "catalog/items/fire-extinguisher/fire-extinguisher.png";